import * as Sentry from '@sentry/vue'

export const Raven = {
  captureException(error, options = {}) {
    return Sentry.captureException(error, options)
  },

  captureMessage(message, level = 'info') {
    return Sentry.captureMessage(message, level)
  },
}

export default Raven
